import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import {
  useGetGigClaims,
  useGetMyAccount,
  useGetMyProfile,
} from "../../../../api/queries";
import useSiteConfigAuth from "../../../../api/sanity/queries/getSiteConfigWithCode";
import AllGigs from "../../../../components/AllGigsTable";
import H2 from "../../../../components/H2";
import Spacer from "../../../../components/Spacer";
import { sendProperty } from "../../../../helpers/helpers";
// import AppState from "../../../../store/appstate";
import useAppStore from "../../../../store/appStateZustand";

function Gigs() {
  const { t } = useTranslation(["dashboard", "gigs", "countries"]);
  const history = useHistory();
  const { data: siteConfig } = useSiteConfigAuth();
  if (siteConfig.disable_gigs) {
    history.push("/");
  }
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });
  const gigClaims = useGetGigClaims({
    ac: selectedAccount,
    oc: myAccount?.data?.originatorcode?.code,
  });
  const profile = useGetMyProfile();
  // const hubspotProps = AppState.useState(s => s.hubspot);
  const hubspotProps = useAppStore(s => s.hubspot);

  const noGigs = siteConfig?.disable_gigs;
  useEffect(() => {
    if (noGigs) {
      history.push("/");
    }
  }, [noGigs, history]);

  useEffect(() => {
    if (selectedAccount) {
      gigClaims.refetch();
    }
  }, [selectedAccount, gigClaims]);

  useEffect(() => {
    if (profile.isSuccess && gigClaims.isSuccess) {
      if (
        !hubspotProps?.songs
        || hubspotProps?.songs !== gigClaims?.data?.length
      ) {
        sendProperty({
          property: "gigs",
          value: gigClaims?.data?.length,
          email: profile.data.email,
        });
        // AppState.update((s) => {
        //   s.hubspot.songs = gigClaims?.data?.length;
        // });
        useAppStore.setState(s => ({ hubspot: { ...s.hubspot, songs: gigClaims?.data?.length } }));
      }
    }
  }, [profile.isSuccess, gigClaims.isSuccess, hubspotProps?.songs, gigClaims?.data?.length, profile.data.email]);

  return (
    <>
      <div className="flex-1 order-last xl:w-full bg-sentric-rebrand-light-grey min-h-50 lg:min-h-screen-minus-header">
        <H2>{t("gigs:your-gigs-header")}</H2>
        <Spacer />
        <AllGigs />
      </div>
    </>
  );
}
export default Gigs;
